// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2Lc7s","author":"Table_author__2MfAZ","authorImage":"Table_authorImage__1OoRj","unreadRow":"Table_unreadRow__2ECzj"};